export default "<p>witaj w panelu administracyjnym</p>\n";